export default __webpack_public_path__ + "static/thumb-bpress-maxipro-ce1adf41b58bb9b88f6abec1154893de.jpg";